<template>
    <div>
        <el-row class="u-mt-10 u-mb-20">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" v-if="$store.state.user.tipo > 3 && $store.state.user.tipo <= 8">
                    <el-select @change="changeFiltros()" v-model="filtro.instituicao_id" filterable placeholder="Pesquisar Instituição" clearable>
                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                    </el-select>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="16" :md="16">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar por nome" @keyup.native.enter="changeNome()"></el-input>
                </el-col>
                <el-col :xs="24" :sm="4" :md="8">
                    <el-select clearable placeholder="Data de agendamento" no-data-text="Selecione a data" v-model="filtro.data"  @change="changeFiltros()">
                        <el-option :key="1" label="06/01/2026" value="06/01/2026"></el-option>                                              
                    </el-select>
                </el-col>
            </el-row>
        </el-row>

        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Nascimento</th>
                        <th>Deficiência</th>
                        <th>Telefone</th>
                        <th>Data do Agendamento</th>                        
                        <th>Status</th>
                        <th>Data da Inscrição</th>
                        <th>Ação</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td>
                            <template v-if="item.matricula">
                                <a href="javascript:void(0)" @click="abreDossie(item)">{{ item.nome }}</a> 
                            </template>
                            <template v-if="!item.matricula">
                                {{ item.nome }}
                            </template>                            
                            <br>
                            <span style="font-style: italic; font-size: 12px;">{{ item.responsavel }}</span>
                        </td>
                        <td>
                            {{ item.data_nascimento ? $moment(item.data_nascimento).format('DD/MM/YYYY') : '' }}
                        </td>
                        <td>{{ $CONSTANTS.TIPOS_DEFICIENCIA[item.tipo_deficiencia] }}</td>
                        <td> {{ item.telefone }} </td>
                        <td>
                            {{ $moment(item.pre_matricula_vaga_agendamento.data).format('DD/MM/YYYY') }}
                        </td>                       
                        <td>                           
                            <template >
                                <span v-if="item.matricula_efetivada" style="color: #038915; font-weight: bold;">MATRICULADO</span>
                                <span v-if="!item.matricula_efetivada && item.cancelado" style="color: #ff0000; font-weight: bold;">CANCELADO</span>
                                <span v-if="!item.matricula_efetivada && !item.cancelado" style="color: #857104; font-weight: bold;">AGENDADO</span>    
                            </template> 
                        </td>
                        <td>
                            {{ $moment(item.created_at).format('DD/MM/YYYY HH:mm:ss') }}
                        </td>
                        <td>
                            <el-button :disabled="item.matricula_efetivada || item.cancelado" @click="matricularAluno(item)" :type="item.matricula_efetivada || item.cancelado ? 'info' : 'primary'" :title="item.matricula_efetivada ? 'Matriculado' : (item.cancelado ? 'Matrícula cancelada' : 'Matrícular aluno')" icon="el-icon-circle-check" size="mini" ></el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                            <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                </el-col>
            </el-row>
        </div>
        <el-dialog :close-on-click-modal="false" title="DOSSIÊ DO ALUNO" width="90%" top="40px" :visible.sync="dialogDossieAluno" v-on:close="closeDialogDossieAluno">
            <div v-if="dialogDossieAluno" style="margin-top: 20px;">
                <dossie-aluno :id="alunoIdSelected" v-on:changeDossie="changeDossie"></dossie-aluno>
            </div>
        </el-dialog>
    </div>
</template>
<script>

import dossieAluno from '@/components/aluno/dossie'

export default {
    data: () => ({
        dialogDossieAluno: false,
        alunoIdSelected: {},
        statusList: false,
        filtro: {
            nome: '',
            instituicao_id: '',
            data: ''
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [ ]
    }),
    mounted () {

        if(this.$store.state.config.instituicao && this.$store.state.user && this.$store.state.user.tipo <= 3){

            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.loadingInscritos()
    },
    methods: {
        abreDossie(item) {
                        
            this.alunoIdSelected = item.matricula.aluno_id;
            this.dialogDossieAluno = true;
        },
        matricularAluno(item) {

            let queryString = {
                id_pre_matricula: item.id,
                nome: item.nome.toUpperCase(),
                data_nascimento: item.data_nascimento,
                cpf: item.cpf,
                celular: item.celular,
                registro_nasc: item.registro_nasc, 
                responsavel: item.responsavel.toUpperCase(),
                turma_id: item.turma_id, 
                referencia_nacional: item.referencia_nacional,
                instituicao_id: item.instituicao_id
            }

            if(item.referencia_nacional >= 30 && item.referencia_nacional <= 34) {
                delete queryString.referencia_nacional;
                delete queryString.turma_id;
            }

            this.$router.push({ path: '/admin/matricula/passo-a-passo', query: queryString }).catch(() => {})
        },
        changeNome(){

            this.filtro.idade = '';
            this.changeFiltros();
        },
        changeFiltros(){

            this.paginate.page = 1;
            this.loadingInscritos();
        },
        loadingInscritos(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/getAllInscritosPcdPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {
                               
                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingInscritos();
        },
        closeDialogDossieAluno(){

            this.alunoIdSelected = {  };
        },
        changeDossie(actions){

            if(actions.close){

                this.dialogDossieAluno = false;
            }
        },
    },
    components:{ dossieAluno }
}
</script>